// home.js
import React from 'react';

import { TabContent, TabPane, Nav, NavItem, NavLink, Col } from 'reactstrap';
import classnames from 'classnames';

import Processes from './Processes';
import Editals from './Editals';
import Contracts from './Contracts';

const Documentation = ({ activeTab, setActiveTab, showNav }) => {
    return (
        <div
            className="mt-3 mr-3"
            style={{
                marginLeft: '30px'
            }}
        >
            {showNav && (
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'processes'
                            })}
                            onClick={() => {
                                setActiveTab('processes');
                            }}
                        >
                            Processos
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'editals'
                            })}
                            onClick={() => {
                                setActiveTab('editals');
                            }}
                        >
                            Editais
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'contracts'
                            })}
                            onClick={() => {
                                setActiveTab('contracts');
                            }}
                        >
                            Contratos
                        </NavLink>
                    </NavItem>
                </Nav>
            )}
            <TabContent activeTab={activeTab} className="bg-white">
                <TabPane tabId="processes">
                    <Col sm="12">
                        <Processes />
                    </Col>
                </TabPane>
                <TabPane tabId="editals">
                    <Col sm="12">
                        <Editals />
                    </Col>
                </TabPane>
                <TabPane tabId="contracts">
                    <Col sm="12">
                        <Contracts />
                    </Col>
                </TabPane>
            </TabContent>
        </div>
    );
};

export default Documentation;
